<div class="list">
  <app-item
    *ngFor="let signedVacationsItem of signedVacations; trackBy: trackByItems"
    (click)="downloadPdf(signedVacationsItem)">
    <app-mot-signed-vacations-item [signedVacationsItem]="signedVacationsItem"></app-mot-signed-vacations-item>
  </app-item>
</div>
